{#if show}
  <FieldContainer {...container}>

    <div slot="before-area">
      <slot name="before"></slot>
    </div>

    <span slot="input-area">

      {#if container.readonly}
        <Text nm pt="sm" pb="xs" width="100%">
          {value}
        </Text> 
      {/if}

      <NoteInput 
        show={field.type==='area'} 
        {id} 
        {container}
        on:focus={()=>{container.focused=true;}}
        on:blur={()=>{container.focused=false;}}
        bind:value={value} />

      <StringInput 
        show={field.type!=='area'} 
        {id} 
        {type} 
        {container} 
        {field} 
        on:focus={()=>{container.focused=true;}}
        on:blur={()=>{container.focused=false;}}
        bind:value={value} />

    </span>

    <div slot="limits-area">{container.limits}</div>

    <div slot="after-area">
      <slot name="after"></slot>
    </div>

  </FieldContainer>
{/if}

<script>
  import { onMount } from 'svelte'
  import { Text } from 'svelte-stylo';
  import FieldContainer from '../container/FieldContainer.svelte'
  import { updateContainer } from '../container/helpers'
  import StringInput from './_StringInput.svelte'
  import NoteInput from './_NoteInput.svelte'
  import { copyProps, FieldContainerProps, TextFieldProps } from '../properties'
  import { validateIf, exceedsMaxlength, isEmpty } from '../validators'
  import { randid } from '../helpers'

  export let
    show = true,
    value,
    container = {...FieldContainerProps},
    field = {...TextFieldProps},
    validators = [exceedsMaxlength, isEmpty];

  let
    id = null,
    layout = 'inline',
    type = field.type,
    maxch = null;

  value = (value === null && field.initial !== null) ? field.initial : value;
  id = field.id || randid();

  onMount(() => {
    // width of input box in chars
    // we assumed a char width of 16px to calculate it 
    // and apply a safety value of 10 chars to change before end
    try {
      let bounds = document.getElementById(id).getBoundingClientRect();
      field.maxch = parseInt(bounds.width / 16) ;
    }
    catch (err) {
      field.maxch = 20;
    }
  })

  $: if ($$props) {
    // copy simple props if the exist
    container = copyProps(container, $$props);
    field = copyProps(field, $$props);
  }

  $: if (field !== null && container !== null) {
    container = updateContainer(container, field, value, "auto");
    type = field.type;
  };

  $: if (value!==null) {
    container.errors = validateIf(value, field, validators)

    container.limits = field.maxlen 
      ? (value || '').length+" / "+field.maxlen
      : "";
    
    container = updateContainer(container, field, value, "auto");
  }

</script>
